<template>
  <b-button-group>
    <b-button
      :variant="$store.state.themeEditor.previewMode === 'desktop' ? 'gradient-primary' : 'light'"
      @click="$store.commit('themeEditor/UPDATE_PREVIEW_MODE', 'desktop')"
    >
      <material-icon
        icon="desktop_windows"
        size="21"
      />
    </b-button>
    <b-button
      :variant="$store.state.themeEditor.previewMode === 'mobile' ? 'gradient-primary' : 'light'"
      @click="$store.commit('themeEditor/UPDATE_PREVIEW_MODE', 'mobile')"
    >
      <material-icon
        icon="phone_iphone"
        size="21"
      />
    </b-button>
<!--    <b-button-->
<!--      :variant="$store.state.themeEditor.previewMode === 'fullscreen' ? 'gradient-primary' : 'light'"-->
<!--      @click="$store.commit('themeEditor/UPDATE_PREVIEW_MODE', 'fullscreen')"-->
<!--    >-->
<!--      <material-icon-->
<!--        icon="width"-->
<!--        size="21"-->
<!--      />-->
<!--    </b-button>-->
  </b-button-group>
</template>

<script>
import {
  BButton, BButtonGroup,
} from 'bootstrap-vue'
import { ref } from 'vue'
import searchAndBookmarkData from '../search-and-bookmark-data'

export default {
  components: {
    BButtonGroup,
    BButton,
  },
  setup() {
    const bookmarks = ref(searchAndBookmarkData.pages.data.filter(page => page.isBookmarked))

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    }

    return {
      bookmarks,
      perfectScrollbarSettings,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

ul
{
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

.nav-bookmar-content-overlay {
    position: fixed;
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-transition: all 0.7s;
    transition: all 0.7s;
    z-index: -1;

    &:not(.show) {
      pointer-events: none;
    }

    &.show {
      cursor: pointer;
      z-index: 10;
      opacity: 1;
    }
}
[dir] .bg-gradient-primary:hover:not(.disabled):not(:disabled), [dir] .btn-gradient-primary:hover:not(.disabled):not(:disabled) {
  transform: unset;
}
</style>
